import { render, staticRenderFns } from "./StageCreateBlock.vue?vue&type=template&id=2aa537bc&scoped=true&"
import script from "./StageCreateBlock.vue?vue&type=script&lang=js&"
export * from "./StageCreateBlock.vue?vue&type=script&lang=js&"
import style0 from "./StageCreateBlock.vue?vue&type=style&index=0&id=2aa537bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa537bc",
  null
  
)

export default component.exports